<template lang="pug">
  .container-error
    .item
      h1
        font-awesome-icon.item-icon(icon="sync")
        span {{ $t('Cannot assign items')}}
    .item.description
      h6 {{ this.$store.state.Error.axios_error.config.url}}
      h4.warning {{ $t(this.$store.state.Error.axios_error.data.displayError) }}
      h4.warning {{ $t(this.$store.state.Error.axios_error.data.message) }}
    .item
    .item.item-acknowledge
      el-button(id="Error400-assignButton" type="warning", size="small", @click="ackError", plain)
        span {{ $t('OK') }}
</template>
<script>
export default {
  props: ['error'],
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    ackError () {
      this.$emit('ackError')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
@import "./error.scss";
</style>



// WEBPACK FOOTER //
// src/components/Error/errorAssign.vue